import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoPlatformAuthRpcClientContext } from "@redotech/redo-merchant-app-common/platform/redo-platform-rpc-client-provider";
import { PlatformType } from "@redotech/redo-merchant-platform-rpc/schema/get-enabled-platforms";
import { createContext, memo } from "react";

export interface InventoryManagementSuiteStatuses {
  imsEnabled: boolean;
}

export const EcommerceProvidersContext = createContext<
  PlatformType[] | undefined
>(undefined);

export const EcommerceProvidersContextProvider = memo(
  function EcommerceProvidersContextProvider({
    children,
  }: {
    children: React.ReactNode;
  }) {
    const platformClient = useRequiredContext(RedoPlatformAuthRpcClientContext);

    const isCommentsoldActiveLoad = useLoad(
      () => platformClient.getEnabledPlatforms(null),
      [platformClient],
    );

    return (
      <EcommerceProvidersContext.Provider value={isCommentsoldActiveLoad.value}>
        {children}
      </EcommerceProvidersContext.Provider>
    );
  },
);
